import { useCallback, useState, useContext } from "react";
import {
    AnalyticsContext,
    ObjectNames,
    ResponseContext,
    ScreenNames,
    TableContext,
} from "@swiggy-private/portal-dineout-context";
import { useConfigTheme, useIsV2InApp } from "hooks";
import { useRouter } from "next/compat/router";

export const useGenerateBillConfirmation = () => {
    const [showGenerateBillConfirmationValue, setShowGenerateBillConfirmationValue] = useState(false);
    const [pendingAction, setPendingAction] = useState<string>("");
    const { state } = useContext(ResponseContext);
    const { impressionEvent, clickEvent } = useContext(AnalyticsContext);
    const { restaurantId, tableId, parentOrderId } = useContext(TableContext);
    const { isV2 } = useIsV2InApp();
    const theme = useConfigTheme();
    const router = useRouter();

    const showGenerateBillConfirmation = useCallback(
        (action: string) => {
            setShowGenerateBillConfirmationValue(true);
            setPendingAction(action);
            impressionEvent({
                category: ScreenNames.TRACK,
                action: ObjectNames.IMPRESSION_GENERATE_BILL_POPUP,
                label: action,
                context: JSON.stringify({
                    restaurant_id: restaurantId,
                    table_id: tableId,
                    parentOrderId,
                    table_no: state?.pin?.data?.tableNo,
                    is_v2_config: isV2,
                    theme,
                }),
            });
        },
        [impressionEvent, restaurantId, tableId, parentOrderId, state?.pin?.data?.tableNo, isV2, theme],
    );

    const hideGenerateBillConfirmation = useCallback(() => {
        setShowGenerateBillConfirmationValue(false);
    }, []);

    const primaryClick = useCallback(() => {
        if (pendingAction) {
            clickEvent({
                category: ScreenNames.TRACK,
                action: ObjectNames.CLICK_GENERATE_BILL_POPUP,
                label: pendingAction,
                context: JSON.stringify({
                    restaurant_id: restaurantId,
                    table_id: tableId,
                    table_no: state?.pin?.data?.tableNo,
                    parentOrderId,
                    is_v2_config: isV2,
                    theme,
                }),
            });

            router?.push(pendingAction);
        }
    }, [
        pendingAction,
        clickEvent,
        restaurantId,
        tableId,
        state?.pin?.data?.tableNo,
        parentOrderId,
        isV2,
        theme,
        router,
    ]);

    return {
        showGenerateBillConfirmationValue,
        showGenerateBillConfirmation,
        hideGenerateBillConfirmation,
        primaryClick,
    };
};
